import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { SystemMessagesService } from '@portal-core/system-messages/services/system-messages.service';
import { isEmpty } from 'lodash';
import { Observable, map } from 'rxjs';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatDivider } from '@angular/material/list';
import { SystemMessageListComponent } from '@portal-core/system-messages/components/system-message-list/system-message-list.component';

@Component({
    selector: 'mc-app-drawer-gutter',
    templateUrl: './app-drawer-gutter.component.html',
    styleUrls: ['./app-drawer-gutter.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgIf, MatDivider, SystemMessageListComponent, AsyncPipe]
})
export class AppDrawerGutterComponent implements OnInit {
  private readonly systemMessagesService = inject(SystemMessagesService);

  hasMessages$: Observable<boolean>;

  ngOnInit() {
    this.hasMessages$ = this.systemMessagesService.getItems$().pipe(
      map(messages => !isEmpty(messages))
    );
  }
}
